import type { AppThemeConfig } from "@src/interfaces/theme-config.interface";

/**
 * Comprehensive MedPsych Systems of Alabama theme overrides layered on top of the Optum baseline.
 *
 * Keep this config as deltas only; any token or asset omitted here
 * inherits from the default Optum theme.
 */
export const CMSFOFAL_THEME_CONFIG: AppThemeConfig = {
  theme: {
    colors: {},
  },
  assets: {
    header: {
      title: {
        hidden: true,
      },
      logo: {
        src: "/themes/cmsfofal/logo.png",
        alt: "Comprehensive MedPsych Systems of Alabama Logo",
        style: { width: "250px", height: "100%", isMobile: { width: "200px" } },
      },
    },
    icons: {},
  },
  providerGroupId: 27,
  state: "AL",
  departmentIds: [293, 159, 109],
};
